import React from "react";
import MdmDeviceScreenshotTab from "./DeviceInfoModal_components/MdmDeviceScreenshotTab";
import MdmDeviceFieldScreenshotTab from "./DeviceInfoModal_components/MdmDeviceFieldScreenshotTab";
import MdmDeviceLocationTab from "./DeviceInfoModal_components/MdmDeviceLocationTab";
import MdmDeviceInfoLogTab from "./DeviceInfoModal_components/MdmDeviceInfoLogTab";

const DEVICE_INFO_TABS = [
  { value: "info", label: "Device Info" },
  { value: "screenshot", label: "Screenshot" },
  { value: "field_screenshot", label: "Field Screenshot" },
  { value: "location", label: "Location" },
  { value: "device_config", label: "Device Config" },
  { value: "branding_config", label: "Branding Config" },
  { value: "scan_and_go_config", label: "Scan & Go Config" },
];

const MdmDeviceInfoModal = ({
  isOpen,
  onClose,
  title,
  tab,
  onTabChange,
  onRefresh,
  isRefreshingActiveTab,
  deviceId,
  screenshotUrl,
  screenshotResult,
  fieldScreenshotUrl,
  fieldScreenshotResult,
  activeLogResult,
  parsedInfo,
  locationSource,
  onLocationSourceChange,
  parsedLocation,
  locationLogResult,
  locationHistory,
  retailerId,
  branchId,
  storeCoordinates,
  branchMapData,
  isBranchMapDataLoading,
  branchMapDataError,
  isLocationTabActive,
  parsedLog,
  infoJson,
  logJson,
  truncateText,
  stringifyForTableCell,
}) => {
  if (!isOpen) return null;

  const renderTabContent = () => {
    if (tab === "screenshot") {
      return (
        <MdmDeviceScreenshotTab
          title={title}
          screenshotUrl={screenshotUrl}
          screenshotResult={screenshotResult}
        />
      );
    }
    if (tab === "field_screenshot") {
      return (
        <MdmDeviceFieldScreenshotTab
          title={title}
          screenshotUrl={fieldScreenshotUrl}
          screenshotResult={fieldScreenshotResult}
        />
      );
    }
    if (tab === "location") {
      return (
        <MdmDeviceLocationTab
          locationSource={locationSource}
          onLocationSourceChange={onLocationSourceChange}
          infoJson={infoJson}
          parsedLocation={parsedLocation}
          locationLogResult={locationLogResult}
          locationHistory={locationHistory}
          deviceInfo={parsedInfo}
          retailerId={retailerId}
          branchId={branchId}
          storeCoordinates={storeCoordinates}
          branchMapData={branchMapData}
          isBranchMapDataLoading={isBranchMapDataLoading}
          branchMapDataError={branchMapDataError}
          isLocationTabActive={isLocationTabActive}
        />
      );
    }
    return (
      <MdmDeviceInfoLogTab
        tab={tab}
        infoJson={infoJson}
        activeLogResult={activeLogResult}
        parsedInfo={parsedInfo}
        parsedLog={parsedLog}
        logJson={logJson}
        truncateText={truncateText}
        stringifyForTableCell={stringifyForTableCell}
      />
    );
  };

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-on-surface/40 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative bg-surface-container-lowest w-full max-w-6xl rounded-2xl shadow-2xl overflow-hidden h-[90vh] flex flex-col">
        <div className="p-6 border-b border-outline-variant/10 flex items-center justify-between">
          <div>
            <h2 className="font-headline font-bold text-lg">Device Details</h2>
            <p className="text-xs text-on-surface-variant break-words">{title}</p>
          </div>
          <button
            className="p-2 hover:bg-surface-container-low rounded-full transition-colors text-on-surface-variant"
            onClick={onClose}
            type="button"
          >
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>
        <div
          className={`p-6 flex-1 min-h-0 flex flex-col ${
            tab === "location" ? "overflow-hidden" : "overflow-y-auto"
          }`}
        >
          <div className="mb-4 shrink-0 flex items-start justify-between gap-2">
            <div className="flex flex-1 flex-wrap items-center gap-2 min-w-0">
              {DEVICE_INFO_TABS.map((tabDef) => (
                <button
                  key={tabDef.value}
                  type="button"
                  className={`shrink-0 px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors ${tab === tabDef.value
                      ? "bg-primary text-white"
                      : "bg-surface-container-low text-on-surface-variant hover:bg-surface-container-high"
                    }`}
                  onClick={() => onTabChange(tabDef.value)}
                >
                  {tabDef.label}
                </button>
              ))}
            </div>
            <button
              type="button"
              className="shrink-0 px-3 py-1.5 rounded-lg text-xs font-semibold bg-surface-container-low text-on-surface-variant hover:bg-surface-container-high transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
              onClick={onRefresh}
              disabled={isRefreshingActiveTab || !deviceId || tab === "field_screenshot"}
            >
              {isRefreshingActiveTab ? "Refreshing..." : "Refresh"}
            </button>
          </div>

          <div className={tab === "location" ? "flex flex-1 min-h-0 flex-col" : undefined}>
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MdmDeviceInfoModal;
